export const JUNOS_SCAN_COMMAND = `cnspec scan junos --hostname DEVICE_IP --username USER_NAME --identity-file SSH_IDENTITY_FILE`;
